var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4144_9856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4144_9856)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4144_9856",
    transform: "matrix(0.01 0 0 0.0131579 0 -0.157895)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4144_9856",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFiUlEQVR4nO2cS4gcRRiAaxMfB9/xAV58rF1/L4O7O1W9O/8/a2BFPCiI4GFRVAxRUNGDR0VUvKkH348cBL2IePPgxYMHwfiI5CbiKcZEBXc1ieAjipldqdmZZLu6ep7dU73d/wd1mt2Zqvr6r7+rqruEYBiGYRiGYRiGYRiGYRgmlUDRw1LRr6Bpo7wFT4Sa7in0ZVCrLZ8PGt/331k0kWIuuukoukgUkXBhKZQKv/HdSTBxKfiyKBpS0x2g6HffnQM+isJTst6YF0VgeXn5LKnpeeeVo+kgzDWuFducQOFe0NTqEyX7hRBTXis6Hd1wFSg84K4kvl6r1c4R25xQNe93yGiZYQo0rcek1Ok+bxUF3bgJNK4mowL/kArvEiUgcEfGurmDNJ+DonfjQxf9cvX88sWTrucUKHzcFcJS4XczC83rRQVkGGYWFy+Vin6L9wG9IiYFRNFlUuHHKWPoe3Nzc+eJisjoArrxaCLBzy/VRd5AvbkoNR125Ip/Qo2PiZIQDCGjww47j+ae4KXGB6Wmfx23e0dkhCiqK6NNqBYX7P+TEe0RWRMuLV0gNX2Qcu/90ezs7ktExWV0kQrftkaO1UwTPETNGdD0rXMSpPBZE6qiJARjyjDUiHYl1+7wtUwqCArvlZr+dOSLVVmnm0WJCDKQ0UUqesi+eIOFphq9csEt54KiV1Mmep/ORNGVokQEGcrosAMUfWnNyz4fKcFvzrrpK4eMdSMpiqKzRYkIspfRZkZjZCJj6/ea3xrqS0KFt5u1/V5rNRUoLbNMIjJAatxnD/UD3wCZ/Qt7tlnB0spKRrtPiXaBxrWtvyEVvTnQP0OETxSgQzZ8FqnwQ5HPouSZ31F46rqI9CC7ezGTlSxqzLshN1Og8YuYeI1f95wuSE1PuiooSg64oqRfZ41AGNGsVPhf7Lfq9ED6LDwld4iSAymRkmUe6WKGw3g00qGhoqPKQkDjmknIeW5uSY0/J/4waDQu7HVnJUoO9ErwGvfludMYRHR34o+lwqd6VUqUHOid5FsyosbEJp2b0YHHWAidiQqF+627rgOjJvi0yEjNT8noSM7QRckBe5iaX6rbyx1mDyh3Ga7oMEvpVRciNi/UN6x+OWa2rHNdG4MIn7ajI5zHa7IWIjW+AApP9hmrN4YtUtP3UMdbx62fq71mM8l+isZsOuUSGQbz/KnUeNxq4OGsh6x2+GcsAuIX0U9iTNLa27nKrQTfe4t6JBmdSjwzaKOrKkQ4lzvooFhZ2ZmpjE44Dry8Pm6DpaLnQNFf22nI6mLWtOwEDxofEVnJMLgSd55Cig70aa9ZKo9fCHh8eq55RWabW+kruniC77IoIcRsJjn67J2xI+O0cSuZd0V0H1PhCBlgP0PTeucB69bYi5Kg8M5NKbi2VcTpz3nIcpFI8BMb4lmIG7PDl0zwLMTrBSgVvcVCCiTEkeATOcRrBcsADNneMMIb23MgTT+al5FYSMaM26EsJGNYSMEAjpBiASykWAALKRbAQooFsJBiASykWAALKRbAQooFsJBiASykWAALKY8Q6XjMqVAV3I7AiO1tH8eUOIBn/OfEMqvgdgVGaO/mUYb4SeIBhzyOiWUh/ZGaXrT7SWp8SeQBC+mNeespIUPRZ7mdbsFC0jHHvyYei1V4JKjvvlzkBQvpcSKDokOWjJPmwDKRJyzEwcrKTtf5kkMfJDMKLMRzErdhIZ6TuA0L8ZzEbViI5yRuw0KE3yTOQiixdOI1ibMQikeB7yTOQij+noeVxKXGHyaaxFkIpb+A4yOJsxBKFeIlibMQcsrwlsT7CalikT6TuI3vzgDfZdIz8X6YV7UqLOPvvufpThpzfggoOlo9GXQ00M3bfPc/wzAMwzAMwzAMwzAMw4iC8j8Xvturvxbw2QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyIcon);
export default __webpack_public_path__ + "static/media/SupplyIcon.74d39626f8f097b0dcb8d7cfe6e2f168.svg";
export { ForwardRef as ReactComponent };